export const moderatorFormConfig = [
    { label: "admin-panel-access", value: "adminPanelAccess" },
    { label: "category-moderation", value: "categoryModeration" },
    { label: "feedback-moderation", value: "feedbackModeration" },
    { label: "promotion-access", value: "promotionAccess" },
];
